export default {
    crop: {
        title: "Cortar",
        cropSize: "Tamanho da safra",
        zoom: "Zoom",
        custom: 'Custom',
        post: 'Postagem',
        square: 'Quadrado',
        landscape: 'Paisagem',
        story: 'História',
        portrait: 'Retrato',
        carousel: 'Carrossel',
        commonAspectRatio: 'Razão de aspecto comum',
    },
};
